import {
  Flex,
  type FlexProps,
  HTMLStyledProps,
} from "@zenchef/styled-system/jsx";
import {
  aromaSectionHeader,
  AromaSectionHeaderVariantProps,
} from "@zenchef/styled-system/recipes";
import { ReactNode } from "react";
import { Text } from "../typography/Text";

import { slots } from "../../theme/recipes/sectionHeader";
import { createStyleContext, Slot } from "../../utils/createStyleContext";

const { withProvider, withContext } = createStyleContext(aromaSectionHeader);

export type SectionHeaderSlots = Slot<typeof aromaSectionHeader>;

export const slotsMaps: Record<SectionHeaderSlots, SectionHeaderSlots> =
  slots.reduce(
    (acc, slot) => ({ ...acc, [slot]: slot }),
    {} as Record<SectionHeaderSlots, SectionHeaderSlots>,
  );

export const SectionHeaderContainer = withProvider<HTMLDivElement, FlexProps>(
  Flex,
  slotsMaps.container,
);

export const SectionHeaderWrap = withContext<
  HTMLDivElement,
  FlexProps & AromaSectionHeaderVariantProps
>(Flex, slotsMaps.wrap);

export const SectionHeaderInnerWrap = withContext<HTMLDivElement, FlexProps>(
  Flex,
  slotsMaps.innerWrap,
);

export const SectionHeaderTitle = withContext<
  HTMLSpanElement,
  HTMLStyledProps<"span">
>(Text, slotsMaps.title);

export interface SectionHeaderLayoutProps
  extends AromaSectionHeaderVariantProps {
  children: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export const SectionHeaderLayout = ({
  children,
  actions,
  className,
  ...props
}: SectionHeaderLayoutProps) => (
  <SectionHeaderContainer {...props} className={className}>
    <SectionHeaderWrap fullWidth={props?.fullWidth}>
      <SectionHeaderInnerWrap>{children}</SectionHeaderInnerWrap>
      <SectionHeaderInnerWrap>{actions}</SectionHeaderInnerWrap>
    </SectionHeaderWrap>
  </SectionHeaderContainer>
);
